// Lightweight error logger so caught failures aren't swallowed silently.
export function logError(context, err) {
  // eslint-disable-next-line no-console
  console.error(`[Ember] ${context}:`, err);
}
